import axios from './axiosInstance';

export const getHostBookingDetails = (page, size, sort, sortOrder, search, dateRange, spaceIds, userName, userEmail, type = 'bookings', bookingDateRange, blockedBy) => {
    // Determine endpoint based on type
    let endpoint = 'bookings';
    if (type === 'blocked') endpoint = 'blocked-slots';
    else if (type === 'google') endpoint = 'google-calendar-events';
    
    let url = `/booking/report/host/${endpoint}?page=${page}&size=${size}`;
    
    if (sort) url += `&sort=${sort}`;
    if (sortOrder) url += `&sortOrder=${sortOrder}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (dateRange) url += `&dateRange=${dateRange}`;
    if (bookingDateRange) url += `&bookingDateRange=${bookingDateRange}`;
    if (blockedBy) url += `&blockedBy=${encodeURIComponent(blockedBy)}`;
    
    if (spaceIds && Array.isArray(spaceIds) && spaceIds.length > 0) {
        // Pass as repeated parameter or comma separated depending on backend handling. 
        // Spring @RequestParam List<String> usually accepts comma separated or repeated params.
        // Axios params serializer handles arrays, but we are building string manually.
        // Let's use comma separated for simplicity if backend supports it.
        url += `&spaceIds=${spaceIds.join(',')}`;
    }
    
    if (userName) url += `&userName=${encodeURIComponent(userName)}`;
    if (userEmail) url += `&userEmail=${encodeURIComponent(userEmail)}`;
    
    return axios.get(url);
};

export const downloadHostReport = (sort, sortOrder, search, dateRange, spaceIds, userName, userEmail, type, bookingDateRange, blockedBy) => {
    let url = `/booking/report/host/export?reportType=${type}`;
    if (sort) url += `&sort=${sort}`;
    if (sortOrder) url += `&sortOrder=${sortOrder}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (dateRange) url += `&dateRange=${dateRange}`;
    if (bookingDateRange) url += `&bookingDateRange=${bookingDateRange}`;
    if (blockedBy) url += `&blockedBy=${encodeURIComponent(blockedBy)}`;
    
    if (spaceIds && Array.isArray(spaceIds) && spaceIds.length > 0) {
        url += `&spaceIds=${spaceIds.join(',')}`;
    }
    
    if (userName) url += `&userName=${encodeURIComponent(userName)}`;
    if (userEmail) url += `&userEmail=${encodeURIComponent(userEmail)}`;
    
    return axios.get(url, { responseType: 'blob' });
};

export const getHostSpaces = () => {
    return axios.get('/booking/report/host/spaces');
};

export const getHostLiveCounts = () => {
    return axios.get('/booking/report/host/live-counts');
};

export const getHostReportStats = (bookingDateRange) => {
    let url = `/booking/report/host/stats`;
    if (bookingDateRange) url += `?bookingDateRange=${bookingDateRange}`;
    return axios.get(url);
};
